// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanrecallconsts.proto (package aurora.core.consts.contractrecall, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanrecallconsts.proto.
 */
export const file_consts_loanrecallconsts: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb25zdHMvbG9hbnJlY2FsbGNvbnN0cy5wcm90bxIhYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0cmVjYWxsKqkBChRDb250cmFjdFJlY2FsbFN0YXR1cxIPCgtVTlNQRUNJRklFRBAAEgcKA05FVxABEggKBE9QRU4QAhIWChJQQVJUSUFMTFlfUkVUVVJORUQQAxISCg5GVUxMWV9SRVRVUk5FRBAEEhIKDlBFTkRJTkdfQ0FOQ0VMEAUSDAoIQ0FOQ0VMRUQQBhIMCghSRUpFQ1RFRBAHEhEKDVBFTkRJTkdfQU1FTkQQCCrPAQoaQ29udHJhY3RSZWNhbGxSZWplY3RSZWFzb24SCAoETk9ORRAAEhsKF09VVFNJREVfU1VQUE9SVEVEX0hPVVJTEAESHwobVU5TVVBQT1JURURfTUVTU0FHRV9ERVRBSUxTEAISFwoTVU5LTk9XTl9MT0FOX1JFQ0FMTBADEhMKD0xPQU5fSU5FTElHSUJMRRAEEhsKF0lOVkFMSURfTE9BTl9SRUNBTExfUVRZEAUSEwoPVU5LTk9XTl9MT0FOX0lEEAYSCQoFT1RIRVIQB0IpWidnaXRsYWIucHJ2YmwuY29tL2F1cm9yYS9jb3JlL3NyYy9jb25zdHNiBnByb3RvMw");

/**
 * ContractRecallStatus : the state a Recall is in now
 *
 * @generated from enum aurora.core.consts.contractrecall.ContractRecallStatus
 */
export enum ContractRecallStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: PARTIALLY_RETURNED = 3;
   */
  PARTIALLY_RETURNED = 3,

  /**
   * @generated from enum value: FULLY_RETURNED = 4;
   */
  FULLY_RETURNED = 4,

  /**
   * @generated from enum value: PENDING_CANCEL = 5;
   */
  PENDING_CANCEL = 5,

  /**
   * @generated from enum value: CANCELED = 6;
   */
  CANCELED = 6,

  /**
   * @generated from enum value: REJECTED = 7;
   */
  REJECTED = 7,

  /**
   * @generated from enum value: PENDING_AMEND = 8;
   */
  PENDING_AMEND = 8,
}

/**
 * Describes the enum aurora.core.consts.contractrecall.ContractRecallStatus.
 */
export const ContractRecallStatusSchema: GenEnum<ContractRecallStatus> = /*@__PURE__*/
  enumDesc(file_consts_loanrecallconsts, 0);

/**
 * @generated from enum aurora.core.consts.contractrecall.ContractRecallRejectReason
 */
export enum ContractRecallRejectReason {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: OUTSIDE_SUPPORTED_HOURS = 1;
   */
  OUTSIDE_SUPPORTED_HOURS = 1,

  /**
   * @generated from enum value: UNSUPPORTED_MESSAGE_DETAILS = 2;
   */
  UNSUPPORTED_MESSAGE_DETAILS = 2,

  /**
   * @generated from enum value: UNKNOWN_LOAN_RECALL = 3;
   */
  UNKNOWN_LOAN_RECALL = 3,

  /**
   * @generated from enum value: LOAN_INELIGIBLE = 4;
   */
  LOAN_INELIGIBLE = 4,

  /**
   * @generated from enum value: INVALID_LOAN_RECALL_QTY = 5;
   */
  INVALID_LOAN_RECALL_QTY = 5,

  /**
   * @generated from enum value: UNKNOWN_LOAN_ID = 6;
   */
  UNKNOWN_LOAN_ID = 6,

  /**
   * @generated from enum value: OTHER = 7;
   */
  OTHER = 7,
}

/**
 * Describes the enum aurora.core.consts.contractrecall.ContractRecallRejectReason.
 */
export const ContractRecallRejectReasonSchema: GenEnum<ContractRecallRejectReason> = /*@__PURE__*/
  enumDesc(file_consts_loanrecallconsts, 1);

